import {
  GET_CATEGORIES,
  ADD_CATEGORY,
  ADD_CATEGORY_ERROR,
  UPDATE_CATEGORY,
  UPDATE_CATEGORY_ERROR,
  DELETE_CATEGORY,
  GET_ACTIVE_CATEGORIES,
  GET_ACTIVE_CATEGORIES_ERROR,
  RESET_STORE,
  MANUALLY_TRIGGER_MESSAGE
} from "../types";

const initialState = {
  categories: [],
  categoriesActive: []
};

export const categoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CATEGORIES:
      return { ...state, categories: action.payload };
    case GET_ACTIVE_CATEGORIES:
      return { ...state, categoriesActive: action.payload };
    case GET_ACTIVE_CATEGORIES_ERROR:
      return { ...state, categoriesActiveError: action.payload };
    case ADD_CATEGORY:
      return { ...state, addCategory: action.payload };
    case ADD_CATEGORY_ERROR:
      return { ...state, addCategoryError: action.payload };
    case UPDATE_CATEGORY:
      return { ...state, addCategory: action.payload };
    case UPDATE_CATEGORY_ERROR:
      return { ...state, addCategoryError: action.payload };
    case DELETE_CATEGORY:
      let NewNotifications = state.categories.filter(
        (category: any) => category._id !== action.payload
      );
      return {
        ...state,
        categories: NewNotifications,
        loading: false
      };
    case MANUALLY_TRIGGER_MESSAGE:
      return { ...state, addCategoryError: action.payload };
    case RESET_STORE:
      return { ...state, addCategory: "" };
    default:
      return state;
  }
};
